var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "basic-actions" }, [
    _c("div", { staticClass: "scopes-table" }, [
      _c(
        "div",
        { staticClass: "scopes-table-header" },
        _vm._l(_vm.columns, function (column) {
          var _obj
          return _c(
            "div",
            {
              key: column.id,
              staticClass: "scopes-table-header-item",
              class:
                ((_obj = {}), (_obj[column.headerClassNames] = true), _obj),
              style: {
                flex: column.flex,
                width: column.width ? column.width + "px" : "auto",
                "max-width": column.maxWidth ? column.maxWidth + "px" : "auto",
              },
            },
            [[_vm._v(_vm._s(column.title))]],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "scopes-table-body" },
        _vm._l(_vm.rows, function (row) {
          return _c(
            "div",
            { key: row.id, staticClass: "row" },
            _vm._l(_vm.columns, function (column) {
              var _obj
              return _c(
                "div",
                {
                  key: column.id,
                  staticClass: "cell",
                  class:
                    ((_obj = {}), (_obj[column.rowClassNames] = true), _obj),
                  style: {
                    flex: column.flex,
                    width: column.width ? column.width + "px" : "auto",
                    "max-width": column.maxWidth
                      ? column.maxWidth + "px"
                      : "auto",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.toggleActive(row.id, column.slot)
                    },
                  },
                },
                [
                  column.slot === "web"
                    ? [
                        _c("SupsisButton", [
                          _vm.loading &&
                          _vm.loading.item == row.id &&
                          _vm.loading.platform == "web"
                            ? _c(
                                "i",
                                { staticClass: "material-icons spin-effect" },
                                [_vm._v("sync")]
                              )
                            : _vm.isActive(row.id, "web")
                            ? _c(
                                "i",
                                { staticClass: "material-icons text-success" },
                                [_vm._v("done")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "disabled-item",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEffect($event, true)
                                    },
                                    mouseleave: function ($event) {
                                      return _vm.hoverEffect($event, false)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("done"),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("circle"),
                                  ]),
                                ]
                              ),
                        ]),
                      ]
                    : column.slot === "mobile"
                    ? [
                        _c("SupsisButton", [
                          _vm.loading &&
                          _vm.loading.item == row.id &&
                          _vm.loading.platform == "mobile"
                            ? _c(
                                "i",
                                { staticClass: "material-icons spin-effect" },
                                [_vm._v("sync")]
                              )
                            : _vm.isActive(row.id, "mobile")
                            ? _c(
                                "i",
                                { staticClass: "material-icons text-success" },
                                [_vm._v("done")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "disabled-item",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEffect($event, true)
                                    },
                                    mouseleave: function ($event) {
                                      return _vm.hoverEffect($event, false)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("done"),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("circle"),
                                  ]),
                                ]
                              ),
                        ]),
                      ]
                    : column.slot === "email"
                    ? [
                        _c("SupsisButton", [
                          _vm.loading &&
                          _vm.loading.item == row.id &&
                          _vm.loading.platform == "email"
                            ? _c(
                                "i",
                                { staticClass: "material-icons spin-effect" },
                                [_vm._v("sync")]
                              )
                            : _vm.isActive(row.id, "email")
                            ? _c(
                                "i",
                                { staticClass: "material-icons text-success" },
                                [_vm._v("done")]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "disabled-item",
                                  on: {
                                    mouseenter: function ($event) {
                                      return _vm.hoverEffect($event, true)
                                    },
                                    mouseleave: function ($event) {
                                      return _vm.hoverEffect($event, false)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("done"),
                                  ]),
                                  _vm._v(" "),
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("circle"),
                                  ]),
                                ]
                              ),
                        ]),
                      ]
                    : [
                        _c("div", { staticClass: "first-cell" }, [
                          row.icon
                            ? _c("i", { staticClass: "material-icons" }, [
                                _vm._v(_vm._s(row.icon)),
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                            " +
                              _vm._s(row[column.id]) +
                              "\n                        "
                          ),
                        ]),
                      ],
                ],
                2
              )
            }),
            0
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }